module.exports = __webpack_public_path__ + "img/pain-scale-500px.5cf826cf.jpg";